/* France Collectivités – bouton « Voir la description complète / Réduire la description ».
   Sur ordinateur (mise en page 3 colonnes, 1200 px et plus), la hauteur repliée s'aligne
   sur le bas du bloc d'achat (carte principale de la colonne de droite).
   Ailleurs, hauteur fixe de 560 px. Sans JavaScript, la description reste entièrement visible. */
(() => {
  const DEFAULT_MAX = 560;
  const MIN_MAX = 280;
  const LABEL_MORE = 'Voir la description complète';
  const LABEL_LESS = 'Réduire la description';

  const computeMax = (content) => {
    let max = DEFAULT_MAX;
    if (window.matchMedia('(min-width: 1200px)').matches) {
      const card = document.querySelector('.product-side-column .product-main-card');
      if (card) {
        const diff = Math.round(card.getBoundingClientRect().bottom - content.getBoundingClientRect().top);
        if (diff >= MIN_MAX) max = diff;
      }
    }
    content.style.setProperty('--fc-desc-max', max + 'px');
    return max;
  };

  const refresh = (container) => {
    const content = container.querySelector('.fc-product-description__content');
    const toggle = container.querySelector('.fc-product-description__toggle');
    if (!content || !toggle) return;
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    const max = computeMax(content);
    const needed = content.scrollHeight > max + 40;
    if (!needed) {
      content.classList.remove('is-collapsed');
      toggle.hidden = true;
      return;
    }
    toggle.hidden = false;
    content.classList.toggle('is-collapsed', !expanded);
  };

  const initialize = (root) => {
    root.querySelectorAll('[data-fc-description]').forEach((container) => {
      if (container.dataset.fcReady === 'true') return;
      const content = container.querySelector('.fc-product-description__content');
      const toggle = container.querySelector('.fc-product-description__toggle');
      if (!content || !toggle) return;

      container.dataset.fcReady = 'true';
      toggle.textContent = LABEL_MORE;
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        toggle.textContent = expanded ? LABEL_MORE : LABEL_LESS;
        content.classList.toggle('is-collapsed', expanded);
        if (expanded) container.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
      refresh(container);
    });
  };

  const refreshAll = () => {
    document.querySelectorAll('[data-fc-description]').forEach(refresh);
  };

  const start = () => {
    initialize(document);
    setTimeout(refreshAll, 1500);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', refreshAll);
  let t;
  window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(refreshAll, 150); });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
